<script lang="ts">
  // Every mockup page opens with a title + one-line subtitle (e.g. Today:
  // "Punch in and out, and what your day looks like"). `onBack`, when given,
  // renders the small back-arrow button the mockup uses on drill-down pages
  // (e.g. a Directory person detail) instead of a nav item.
  import { ArrowLeft } from 'lucide-svelte';

  const {
    title,
    subtitle,
    onBack
  }: { title: string; subtitle?: string; onBack?: () => void } = $props();
</script>

<div class="flex min-w-0 items-center gap-3">
  {#if onBack}
    <button
      type="button"
      aria-label="Back"
      class="-ml-1 flex h-8 w-8 shrink-0 items-center justify-center rounded-lg border border-toyama-cloudy-gray bg-surface text-navy hover:bg-surface-2"
      onclick={onBack}
    >
      <ArrowLeft class="h-4 w-4" />
    </button>
  {/if}
  <div class="min-w-0">
    <h1 class="truncate font-heading text-[16.5px] font-bold leading-[1.2] tracking-tight text-navy">
      {title}
    </h1>
    {#if subtitle}
      <div class="mt-px truncate text-[11.5px] text-dark-gray">{subtitle}</div>
    {/if}
  </div>
</div>
